// sensei-app/common/schemas/collections/certificates.js
import { z } from "zod";

const CertificateSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    studentId: z.string().describe("The user ID of the student who earned the certificate."),
    courseId: z.string().describe("The course ID for which the certificate was issued."),
    courseName: z.string().describe("The name of the course."),
    studentName: z.string().describe("The full name of the student as it appears on the certificate."),
    issueDate: z.coerce.date().describe("The date the certificate was issued."),
    certificateUid: z.string().uuid().describe("A unique public identifier for verification purposes."),
    filePath: z.string().describe("The relative path to the stored PDF file from UploadDownloadService."),
    createdAt: z.coerce.date().optional(),
});

export default CertificateSchema;